import React, { useState } from "react";
import { Plus, X } from "react-feather";
import { useLocale } from "../hooks/useLocale";

const FileUpload = ({
  register,
  error,
  title = "upload title",
  required,
  name,
  multiple,
  ...props
}) => {
  const [documents, setDocuments] = useState([]);

  const { localize } = useLocale();

  const handleFileUpload = (e) => {
    const files = e.target.files;
    const docs = Object.values(files).map((file) => URL.createObjectURL(file));
    setDocuments([...docs]);
  };

  const clearUploads = () => {
    setDocuments([]);
  };

  const removeUploadedFile = (key) => {
    const removedFiles = documents.filter((file) => file !== key);
    setDocuments(removedFiles);
  };
  return (
    <>
      <div className="uploads alert">
        <div className="d-flex justify-content-between">
          <h6 className={`text-uppercase ${required && "required"}`}>
            {title}
          </h6>

          {/* Clear Uploaded Docs */}
          {documents.length ? (
            <div>
              <button
                className="btn btn-sm btn-light text-danger"
                onClick={clearUploads}
              >
                <X size={14} /> clear
              </button>
            </div>
          ) : null}
        </div>
        <div className="file-wrapper">
          {/* View Attached Docs */}
          {documents.map((file, index) => {
            return (
              <>
                <div
                  className="file shadow"
                  key={file}
                  // onClick={() => removeUploadedFile(file)}
                >
                  <img className="img-fluid" src={file} />
                </div>
              </>
            );
          })}
          {/* Upload File Input */}
          {!documents.length && (
            <div className={`file-upload`}>
              <input
                type="file"
                multiple={multiple}
                {...register(name, {
                  required: {
                    value: !!required,
                    message: "Please Attach Document",
                  },
                  onChange: (e) => {
                    handleFileUpload(e);
                  },
                })}
                {...props}
              />
              <p>
                <Plus />
                <br />
                <span className="fw-bold">Attach File</span>
              </p>
            </div>
          )}
        </div>
      </div>
      {error && <div className="alert alert-danger p-2">{error?.message}</div>}
      <div class="alert alert-warning p-2">{localize("common.note")}</div>
    </>
  );
};

export { FileUpload };
